/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {DocumentDto} from '../models/DocumentDto';
import type {DocumentVersionDto} from '../models/DocumentVersionDto';

import type {CancelablePromise} from '../core/CancelablePromise';
import {OpenAPI} from '../core/OpenAPI';
import {request as __request} from '../core/request';
import {DocumentUsedDto} from '../models/DocumentUsedDto';
import {DocumentAdditionalAttributesDto} from '../models/DocumentAdditionalAttributesDto';
import {DocumentIdAngLanguageCodeDto} from '../models/DocumentIdAngLanguageCodeDto';
import { DocumentUpdateDto } from '../models/DocumentUpdateDto';

export class DocumentService {
  /**
   * @returns DocumentDto Success
   * @throws ApiError
   */
  public static getDocument(): CancelablePromise<Array<DocumentDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/document'
    });
  }

  /**
   * @param id
   * @returns DocumentUsedDto Success
   * @throws ApiError
   */

  public static getRelatedDocuments(
    id: string,
    languageCode: string
  ): CancelablePromise<Array<DocumentUsedDto>> {
    var body = {
      documentId: id,
      languageCode: languageCode
    };
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Document/Children',
      body: body
    });
  }

  public static createDynamicLink(
    requestBody?: DocumentIdAngLanguageCodeDto
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Document/dynamicLink',
      body: requestBody
    });
  }

  public static changeAdditionalAttributes(processId:number, requestBody?: DocumentAdditionalAttributesDto): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Process/{id}/UpdateAdditionalAttributes',
      body: requestBody,
      mediaType: 'application/json',
      path: {
        id: processId
      }
    });
  }
  /**
   * @param id
   * @returns DocumentVersionDto Success
   * @throws ApiError
   */
  public static getApiDocumentVersion(id: number): CancelablePromise<Array<DocumentVersionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/Document/{id}/Version',
      path: {
        id: id
      }
    });
  }

  /**
   * @param id
   * @returns BatchAcknowledgementElementDto Success
   * @throws ApiError
   */
  public static putDocumentUpdate(
    id: number,
    requestBody: DocumentUpdateDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/Document/update/{id}',
      path: {
        id: id
      },
      body: requestBody,
      mediaType: 'application/json'
    });
  }
  
   /**
   * @returns Post User Open Document
   * @throws ApiError
   */
   public static postUserActivityForDocument(
    requestBody: DocumentIdAngLanguageCodeDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/Document/userActivityLog',
      body: requestBody,
      mediaType: 'application/json'
    });
  }

}




